
const musicAlbums = [

 {name: "Random  Hitz",
        cover: "rh.jpg",
        songs: [
          { title: "Mountain off  you", file: "random/burden.mp4" },
          { title: "My Head", file: "random/my head.mp4" },
          { title: "Tippn4", file: "random/Tippn4.mp4" },
          { title: "Alpo Pup", file: "random/alpo Pup.mp4" },
          { title: "Bush no more", file: "random/bush no more.mp4" },
          { title: "Calipillas", file: "random/calipillas.mp4" },
          { title: "Calipillas(remix)", file: "random/calipillas2.mp4" },
          { title: "Hope she don't do me wrong", file: "random/hsddmw.mp4" },
          { title: "I won't do him wrong", file: "random/iwdhw.mp4" },
          { title: "Didn't do wrong", file: "random/ddw.mp4" },
          { title: "Bitch in you", file: "random/biy.mp4" },
          { title: "Don't start none", file: "random/dont start none.mp4" },
          { title: "Don't Blame me", file: "random/dbm.mp4" },
          { title: "Don't Blame me(remix)", file: "random/dbmr.mp4" },
          { title: "My one girl(remix)", file: "random/bout it boo.mp4" },
          { title: "Bout it Boo", file: "random/bout it boo.mp4" },
         
         ],
      },

  
{
name: "Christmas Joy",
        cover: "xmasep.jpg",
        songs: [
          { title: "All the little Shorties", file: "xmasepU/pre/atls.mp4" },
          { title: "Eyez of the children", file: "xmasepU/pre/eotc.mp4" },
          { title: "Slippn and Slidn in the snow", file: "xmasepU/pre/crlr.mp4" },
          { title: "Fat man in red(flying around)", file: "xmasepU/pre/fmir.mp4" },
          { title: "Santa could use more help", file: "xmasepU/pre/scumh.mp4" },
         ],
      },
      


      {name: "Male R&b Hitz",
        cover: "mrb2.jpg",
        songs: [
          { title: "BenduOva", file: "malernbU/pre/benduova.mp4" },
          { title: "I'm coming back", file: "malernbU/pre/ComingBack.mp4" },
          { title: "Have and Hold", file: "malernbU/pre/HAVEandhold.mp4" },
          { title: "Her big payback", file: "malernbU/pre/BIGPAYback.mp4" },
          { title: "Beautiful in every way", file: "malernbU/pre/Ineveryway.mp4" },
          { title: "Top Billing", file: "malernbU/pre/TOPBILLingvidMAS1.mp4" },
          { title: "You would think", file: "malernbU/pre/youwouldthink.mp4" },
          { title: "I get up", file: "malernbU/pre/Igetup.mp4" },
          { title: "Here Dear", file: "malernbU/pre/HearDear.mp4" },
          { title: "Thatz how much", file: "malernbU/pre/thatzhowmuch.mp4" },
          { title: "Bad 4 me", file: "malernbU/pre/BAD4ME.mp4" },
         ],
      },
      
        {name: "Country Hitz",
        cover: "mcountry.jpg",
        songs: [
          { title: "My one Girl", file: "countryU/pre/Myonegirl.mp4" },
          
         { title: "Your lipz(long version)", file: "countryU/pre/butyourlipx(vs2).mp4" },
          { title: "All dressed up", file: "countryU/pre/01-Alldressedup.mp4" },
          { title: "Where the bull is at", file: "countryU/pre/02-Bullisat.mp4" },
          { title: "Without you", file: "countryU/pre/WithoutYou.mp4" },
          { title: "Never love and leave", file: "countryU/pre/neverloveandleave.mp4" },
          { title: "Don't let the Girl get away", file: "countryU/pre/Getaway.mp4" },
          { title: "Your lipz", file: "countryU/pre/butyourlipz.mp4" },
          { title: "Daddies never", file: "countryU/pre/Daddiesnever.mp4" },
          { title: "Wouldn't be here", file: "countryU/pre/Wouldn'tBeHere.mp4" },
          { title: "Phenomenon", file: "countryU/pre/Phenomenon.mp4" },
          { title: "Let her go", file: "countryU/pre/LetHerGo.mp4" },
         ],
      },
      {name: "Adult sexxxy Hitz",
        cover: "asexy.jpg",
        songs: [
          { title: "At least six", file: "adultsexxyU/pre/atleast6.mp4" },
          { title: "Over the top", file: "adultsexxyU/pre/OverTheTop.mp4" },
          { title: "No sexier", file: "adultsexxyU/pre/nosexxier.mp4" },
          { title: "Ready2rush", file: "adultsexxyU/pre/ready2rush.mp4" },
          { title: "All out of wordz", file: "adultsexxyU/pre/Alloutofwords.mp4" },
          { title: "Puddn 2night", file: "adultsexxyU/pre/pudding2nite.mp4" },
          { title: "Inside of me", file: "adultsexxyU/pre/insideofme.mp4" },
          { title: "Another zero", file: "adultsexxyU/pre/anotherzero.mp4" },
          { title: "Water", file: "adultsexxyU/pre/Water.mp4" },
          { title: "Wanna see me naked", file: "adultsexxyU/pre/nakedsee.mp4" },
          { title: "Pretty box", file: "adultsexxyU/pre/PrettyBox.mp4" },
         ],
      },
      {name: "Girlz with guitars",
        cover: "gwg.jpg",
        songs: [
          { title: "Exist with men", file: "gwgU/pre/existwithmen.mp4" },
          { title: "Something strange", file: "gwgU/pre/somethingstrange.mp4" },
          { title: "Effing girlfriend", file: "gwgU/pre/FKINGgirlfriend.mp4" },
          { title: "Only wanna hurt", file: "gwgU/pre/onlywannahurt.mp4" },
          { title: "Pretty face", file: "gwgU/pre/prettyface.mp4" },
          { title: "MommyDaddy", file: "gwgU/pre/mommydaddy.mp4" },
          { title: "Trouble man", file: "gwgU/pre/troubleman.mp4" },
          { title: "Body U body me(remix)", file: "gwgU/pre/bybme.mp4" },
          { title: "Hero", file: "gwgU/pre/hero.mp4" },
          { title: "Sentimental", file: "gwgU/pre/sentimental.mp4" },
          { title: "Tower of peace", file: "gwgU/pre/towerofpeace.mp4" },
         ],
      },
      {name: "Female R&b Hitz",
        cover: "frb1.jpg",
        songs: [
          { title: "Lady luck", file: "femalernbU/pre/LadyLuck.mp4" },
          { title: "Superman's Girl", file: "femalernbU/pre/SuperManGirl.mp4" },
          { title: "Love and Fantasy", file: "femalernbU/pre/LoveFantasy.mp4" },
          { title: "body you body me(remix)", file: "femalernbU/pre/bodyyoubodyme(remix).mp4" },
          { title: "Sentimental", file: "femalernbU/pre/sent.mp4" },
          { title: "Little boy smile", file: "femalernbU/pre/BoySmile.mp4" },
          { title: "Take care of me", file: "femalernbU/pre/Business.mp4" },
          { title: "Keep it clapping", file: "femalernbU/pre/clapping.mp4" },
          { title: "Cold day", file: "femalernbU/pre/cold day.mp4" },
          { title: "Take it there", file: "femalernbU/pre/TakeItThere.mp4" },
          { title: "If I say one", file: "femalernbU/pre/ifisayone.mp4" },
          { title: "Grow up", file: "femalernbU/pre/Growup.mp4" },
         ],
      },
      {name: "Female Pop Hitz",
        cover: "fpop.jpg",
        songs: [
          { title: "BreaknNewz", file: "femalepopU/pre/BreakNewz.mp4" },
          { title: "Don't cry", file: "femalepopU/pre/don'tcry.mp4" },
          { title: "Confess", file: "femalepopU/pre/confess.mp4" },
          { title: "Little Sister", file: "femalepopU/pre/LittleSister.mp4" },
          { title: "Pop Queen", file: "femalepopU/pre/PopQueen.mp4" },
          { title: "Just because", file: "femalepopU/pre/justbecause.mp4" },
          { title: "You know it", file: "femalepopU/pre/YouKnowIt.mp4" },
          { title: "Win my heart", file: "femalepopU/pre/WinMyheart.mp4" },
          { title: "Whereever you are", file: "femalepopU/pre/Whereeveryouare.mp4" },
          { title: "How does it feel", file: "femalepopU/pre/howdoezitfeel.mp4" },
          { title: "Outside walking", file: "femalepopU/pre/outsidewalking.mp4" },
         ],
      },
      {name: "Aphrodite body",
        cover: "abody.jpg",
        songs: [
         { title: "Betty Boop that azz", file: "aphroditeU/pre/Bettyboopdatazz.mp4" },
          { title: "Kind of wild Girl", file: "aphroditeU/pre/kindofwildgirl.mp4" },
          { title: "I know what I like", file: "aphroditeU/pre/Know whatIlike.mp4" },
          { title: "Heelz up", file: "aphroditeU/pre/HeelsUp.mp4" },
          { title: "Short shortz", file: "aphroditeU/pre/Shortshortz.mp4" },
          { title: "Body you Body me", file: "aphroditeU/pre/bodyyouyoubody me.mp4" },
          { title: "Lookahere", file: "aphroditeU/pre/lookahere.mp4" },
          { title: "Can't nobody", file: "aphroditeU/pre/Likemybody.mp4" },
          { title: "Party Girl", file: "aphroditeU/pre/PartyGirl.mp4" },
          { title: "Season no reason", file: "aphroditeU/pre/Seasonsnoreason.mp4" },
          { title: "Aphrodite body", file: "aphroditeU/pre/Aphroditebody.mp4" },
         ],
      },
      {name: "R&b Duetz Hitz",
        cover: "rbduet.jpg",
        songs: [
        { title: "Happy Anniversary", file: "duetsU/pre/HappyAnniversary.mp4" },
          { title: "I got the heart", file: "duetsU/pre/Gotthe heart.mp4" },
          { title: "Distance between us", file: "duetsU/pre/distancebetweenus.mp4" },
          { title: "Extra mile", file: "duetsU/pre/Extramile.mp4" },
          { title: "I really love you", file: "duetsU/pre/reallyloveU.mp4" },
          { title: "Feel you are the one", file: "duetsU/pre/Theone.mp4" },
          { title: "Shaking the bed", file: "duetsU/pre/Shakingthebed.mp4" },
          { title: "Heart2heart", file: "duetsU/pre/heart2heart.mp4" },
          { title: "Moment away", file: "duetsU/pre/momentaway.mp4" },
          { title: "Wanted 2 say", file: "duetsU/pre/Iwanted2say.mp4" },
          { title: "Play the heartz", file: "duetsU/pre/Playtheheartz.mp4" },
         ],
      },
      {name: "Female R&b2 Hitz",
        cover: "frb2.jpg",
        songs: [
          { title: "Your City", file: "femalernb2U/pre/toyourcity.mp4" },
          { title: "God made it like this", file: "femalernb2U/pre/dashyt.mp4" },
          { title: "Misery wantz her lover", file: "femalernb2U/pre/Miserywantzherlover.mp4" },
          { title: "Lock you down", file: "femalernb2U/pre/lockyoudown.mp4" },
          { title: "Feeling this", file: "femalernb2U/pre/feelingthis.mp4" },
          { title: "No Finance no Romance", file: "femalernb2U/pre/NoFinance.mp4" },
          { title: "Handz in the air", file: "femalernb2U/pre/handzintheair.mp4" },

          { title: "Don't show", file: "femalernb2U/pre/dontshow.mp4" },
          { title: "Aint the one", file: "femalernb2U/pre/ainttheone.mp4" },
          { title: "Whereever you are", file: "femalernb2U/pre/wya.mp4" },
         ],
      },
      {name: "New Genesis soundtrack1",
        cover: "ngst.jpeg",
        songs: [
          { title: "Not shy", file: "ngU/pre/notshy.mp4" },
          { title: "Chump get up", file: "ngU/pre/chumpgetup.mp4" },
          { title: "About 2 die", file: "ngU/pre/about2die.mp4" },
          { title: "Don't look back", file: "ngU/pre/don'tlookback.mp4" },
          { title: "Iceman friend", file: "ngU/pre/icemanfriend.mp4" },
          { title: "Too Hott", file: "ngU/pre/toohott.mp4" },
          { title: "Light of the World", file: "ngU/pre/lightoftheworld.mp4" },
          { title: "Her name is", file: "ngU/pre/hernameis.mp4" },
          { title: "Loving armz", file: "ngU/pre/lovingarmz.mp4" },
          { title: "Feifong song", file: "ngU/pre/Feifongsong.mp4" },
          { title: "Big Cat", file: "ngU/pre/bigcat.mp4" },
          { title: "Like this Like you", file: "ngU/pre/likethislikeyou.mp4" },
         ],
      },
      {name: "New Genesis(Return) soundtrack 2",
        cover: "NEWGEN2.jpg",
        songs: [
           { title: "Your highness", file: "ng2U/pre/yourhighness.mp4" },
          { title: "Dragon by the toe", file: "ng2U/pre/Dragonbythetoe.mp4" },
          { title: "Justice", file: "ng2U/pre/justice.mp4" },
          { title: "I'll be free", file: "ng2U/pre/prisoner.mp4" },
          { title: "Long way 2 nowhere", file: "ng2U/pre/longway2nowhere.mp4" },
          { title: "Rootzwoman", file: "ng2U/pre/rootzwoman.mp4" },
          { title: "My mouth broke my heart", file: "ng2U/pre/mymouth1.mp4" },
          { title: "My mouth(remix)", file: "ng2U/pre/mymouth.mp4" },
          { title: "Freedom Fighter", file: "ng2U/pre/freedomfighter.mp4" },
          { title: "Day of mourning", file: "ng2U/pre/DayofMourning.mp4" },
          { title: "Chasing Rainbows", file: "ng2U/pre/rainbows.mp4" },
         ],
      },
      {name: "House of Cush sountrack",
        cover: "unaccept1.jpg",
        songs: [
         { title: "InInanna", file: "houseU/pre/inanna.mp4" },
          { title: "My Meri", file: "houseU/pre/Meri.mp4" },
          { title: "Under a Spell", file: "houseU/pre/UnderaSpellfinal.mp4" },
          { title: "Nieghborhood", file: "houseU/pre/nieghborhood.mp4" },
          { title: "Between 2 worldz", file: "houseU/pre/between2worlds.mp4" },
          { title: "Brother's eyez", file: "houseU/pre/Brother'sEyes.mp4" },
          { title: "Communist", file: "houseU/pre/imacommunist.mp4" },
          { title: "Tower of Babel", file: "houseU/pre/towerofbabel.mp4" },
          { title: "2 my love", file: "houseU/pre/2myluv.mp4" },
          { title: "Da fuck you", file: "houseU/pre/dafucku.mp4" },
          { title: "WillyDo", file: "lostsonU/pre/willydo.mp4" },
         ],
      },
      {name: "Nimrod:Lost son",
        cover: "unaccept2.jpg",
        songs: [
           { title: "Oppose the devil", file: "lostsonU/pre/opposedevil.mp4" },
           { title: "Bless U", file: "lostsonU/pre/blessu.mp4" },
          { title: "Old School", file: "lostsonU/pre/oldschool.mp4" },
          { title: "Down there", file: "lostsonU/pre/downthere.mp4" },
          { title: "Dey come", file: "lostsonU/pre/deycome.mp4" },
          { title: "Roll with Nimrod", file: "lostsonU/pre/rollwithNimrod.mp4" },
          { title: "Black love", file: "lostsonU/pre/BlackLove.mp4" },
          { title: "Say 2 U", file: "lostsonU/pre/say2u.mp4" },
          { title: "Would it be", file: "lostsonU/pre/Woulditbe.mp4" },
          { title: "Like mind", file: "lostsonU/pre/likemind.mp4" },
          { title: "Who you praying to", file: "lostsonU/pre/pray.mp4" },
      
        ],
      },
    ];
    
   

export default musicAlbums;